import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import _moment from 'proxies/dayjs';

@Component({
    selector: 'app-generic-profile',
    templateUrl: './generic-profile.component.html',
    styleUrls: ['./generic-profile.component.scss'],
    standalone: false
})
export class GenericProfileComponent implements OnInit {
  public _currentData: any = {};
  isPopup: boolean = false
  profile_path: any;
  moment = _moment;

  constructor(
    private loader: LoaderService,
    private alert: AlertsService,
    private route: Router,
    private baseService: BaseService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private dialogConfig: DialogConfig,
    public utilService: UtilService,
    private appService: AppService,
    public authenticationService: AuthenticationService,
  ) {

  }

  ngOnInit(): void {
    // var resource = this.activatedRoute.snapshot.params.resource
    if (Object.keys(this.dialogConfig).length == 0) {
      let resource = this.activatedRoute.snapshot.params.resource;
      this.baseService.getResourceDef(resource, (data) => { //in case of other roles irrespective of patient
        this._currentData['resourceDef'] = data;
        this._currentData['cards'] = data.cards;
        this.baseService.setTitle("Profile");
        this.baseService.backNavigation = true;
        //get data from prev row
        this.getData();
        //setting obj
        this.getDeatails(data);
      })
    } else {
      this.isPopup = true
      let resource = this.dialogConfig.resource
      this.baseService.getResourceDef(resource, (data) => { //in case of other roles irrespective of patient
        this._currentData['resourceDef'] = data;
        this._currentData['cards'] = data.cards;
        this._currentData['prevData'] = { id: this.dialogConfig['id'] };
        if (this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data != undefined) {
          this._currentData['prevData'] = this.dialogConfig['data'];
        }
        //get data from prev row
        // this.getData();
        //setting obj
        // this.getDialogConfigData()
        this.getDeatails(data);
      })
    }
    // this.getResource();


  }

  // getDialogConfigData() {
  //   this.baseService.get("GET_BY_ID", "id:" + this.dialogConfig.id, this.dialogConfig.application_resource, this.dialogConfig.application).subscribe((res: any) => {
  //     if (res) {
  //       this._currentData['prevData'] = res.resource[0];
  //     }
  //   })
  // }

  getData() {
    this.storageService.getSessionStorageData('currentData', (data) => {
      if (data) {
        this._currentData['prevData'] = data;
      }
    })
  }


  getDeatails(Json_) {
    this.loader.showSpinner();
    let datasource = Json_.APIresource.datasource;
    let params = {
      filter: datasource.filter != undefined ? this.baseService.buildDyanamicStr(Json_.APIresource.datasource.filter, { data: this._currentData['prevData'] }) : "",
      args: datasource.args != undefined ? this.baseService.buildDyanamicStr(Json_.APIresource.datasource.args, { data: this._currentData['prevData'] }) : ""
    }

    this.baseService.getData(params, "", datasource.resource, datasource.application, datasource.query_id).subscribe((res: any) => {
      this.loader.hideSpinner()
      if (res.errCode == -1) {
        this.alert.error(res.message);
        this._currentData.userdetails = [];
      } else {
        this._currentData.userdetails = res.resource[0];
        this.profile_path = 'dms/api/v1/userImage/image-response-entity?args=id:' + this._currentData.userdetails[Json_.cards.find(x => x.type == "profile").profile_key]
      }
    },
      err => {
        this.loader.hideSpinner()
      }
    )
  }

  navigationBack() {
    this.activatedRoute.queryParams.subscribe((result) => {
      this.route.navigateByUrl(result['returnUrl'])
    })
  }

  getSignature(key, resourceName) {
    return 'dms/api/v1/' + resourceName + '/image-response-entity?args=id:' + this._currentData.userdetails.extra_data[key];
  }

  calculateValue(item, format, type?, name?) {
    let value; //item = item.sort()
    if (type) {
      if (type == "scheduleTime") {
        let Arr = []; Arr.push(eval(format)(item)); Arr.sort()
        var empt = [];
        if (Arr[0].includes(",")) {
          var q = [];
          for(let i = 0; i < Arr[0].split(",").length; i++) {
            q.push(this.getValue_(Arr[0].split(",")[i]))
          }
          if (q.map(x => x.includes("PM")).includes(true)) {
            return [...q.filter(x => x.split("-")[0].includes("AM")).sort(), ...q.filter(x => x.split("-")[0].includes("PM")).sort()]
          }
          return q.sort()
        } else {
          empt.push(this.getValue(format, item));
          return empt.sort()
        }
      }
    } else {
      value = eval(format)(item);
    }
    return value
  }

        // Copy with util service
      toTimeZoneDate(date: any): any {
        let timeZone;
        let orgObj = this.appService.getOrganization();
          if (orgObj != null && orgObj.time_zone != null) {
            timeZone = orgObj.time_zone;
          } else if (this.appService._currentSessionData["timeZoneAccountCode"] != undefined && this.appService._currentSessionData["timeZoneAccountCode"]) {
            timeZone = this.appService._currentSessionData["timeZoneAccountCode"];
          } else {
            timeZone = this.appService._default_user_data.timezone;
          }
          _moment.tz.setDefault(timeZone);
          return _moment(date).tz(timeZone);
      }


  // Copy with util service
    toTimeZoneDateFormat(date: any, formatType: string): any {
        if (typeof date === 'string') { // Extra check condition if date is not a number
            if (date.indexOf(".")) {
              date = parseFloat(date.trim());//it means long is saved as double
            } else {
              date = parseInt(date.trim());
            }
        }  
        let timeZoneDate = this.toTimeZoneDate(date);
        let date_format; let time_format; let dateTime_format;
        let monthYear_format = this.appService._default_user_data.monthYear_format

        let orgObj = this.appService.getOrganization();
        if (orgObj != null && orgObj.date_format != null) {
          date_format = orgObj.date_format;
        } else {
          date_format = this.appService._default_user_data.data_format;
        }
        if (orgObj != null && orgObj.time_format != null) {
          time_format = orgObj.time_format;
        } else {
          time_format = this.appService._default_user_data.time_format;
        }

      if (orgObj != null && orgObj.dateTime_format != null) {
        dateTime_format = orgObj.dateTime_format;
      } else {
        dateTime_format = this.appService._default_user_data.dateTime_format;
      }
      if (formatType == 'date')
        return timeZoneDate.format(`${date_format}`);
      else if (formatType == 'time') {
        return timeZoneDate.format(`${time_format}`);
      } else if (formatType == 'datetime') {
        return timeZoneDate.format(`${dateTime_format}`);
      } else if (formatType == 'monthYear') {
        return timeZoneDate.format(`${monthYear_format}`)
      }
      else if (formatType == 'time24') {
        return timeZoneDate.format("HH:mm:ss");   // FIXED 24-hr format
      }
  }


  getValue_(value) {
    var s = [];
    for (let i = 0; i < value.split("/").length; i++) {
      s.push(this.toTimeZoneDateFormat(value.split("/")[i], 'time')) // called from Own Component
    }
    return s.join("-")
  }

  getValue(format, item) {
    var s = [];
    if (this.authenticationService.getUserType() == 'patient') {
      for (let i = 0; i < eval(format)(item).split("/").length; i++) {
        s.push(this.toTimeZoneDateFormat(eval(format)(item).split("/")[i], 'time24'))  // called from Own Component
      }
    } else {
      for (let i = 0; i < eval(format)(item).split("/").length; i++) {
        s.push(this.toTimeZoneDateFormat(eval(format)(item).split("/")[i], 'time'))  // called from Own Component
      }
    }

    return s.join("-")
  }

  getDoctorExperince(item?): string {
    const data = item;
    if (!data) return '';
    const designation = data.extra_data.designation || '';
    const experience = data.extra_data.doctor_experience ? `${designation ? ' / ' : ''}${data.extra_data.doctor_experience} yrs` : '';
    return `${designation}${experience}`;
  }

}
